(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kensui-carousel-controller"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kensui-depth-carousel')) {
  class KensuiNativeCarousel extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.best = this.localName === 'kensui-best-carousel';
      this.bars = this.dataset.kind === 'bars';
      this.cssPrefix = this.best ? 'kh-best' : this.bars ? 'kh-bars' : 'kh-sw';
      this.cardSelector = '.' + this.cssPrefix + (this.best ? '__item' : '__card');
      this.grid = this.querySelector('.' + this.cssPrefix + (this.best ? '__stage' : '__grid'));
      this.cards = [...this.grid.querySelectorAll(this.cardSelector)];
      if (!this.cards.length) return;
      this.cards.forEach((card, i) => {
        card.dataset.carouselIndex = i;
        card.querySelectorAll('img').forEach(img => { img.draggable = false; });
      });
      this.dots = [...this.querySelectorAll('[data-slide]')];
      this.media = matchMedia(this.bars ? '(min-width:0px)' : '(max-width:768px)');
      this.reduce = matchMedia('(prefers-reduced-motion:reduce)');
      this.current = 0;
      this.grid.addEventListener('scroll', () => {
        if (!this.media.matches) return;
        this.queuePaint();
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.settle(), 160);
      }, {signal, passive:true});
      this.grid.addEventListener('pointerdown', e => {
        if (!this.media.matches || e.pointerType !== 'mouse' || e.button !== 0) return;
        this.mouse = {id:e.pointerId, x:e.clientX, left:this.grid.scrollLeft, moved:false};
      }, {signal});
      this.grid.addEventListener('pointermove', e => {
        const mouse = this.mouse;
        if (!mouse || e.pointerId !== mouse.id) return;
        const delta = e.clientX - mouse.x;
        if (!mouse.moved && Math.abs(delta) < 5) return;
        if (!mouse.moved) this.grid.setPointerCapture(e.pointerId);
        mouse.moved = true;
        this.dataset.dragging = '';
        this.grid.scrollLeft = mouse.left - delta;
        e.preventDefault();
      }, {signal});
      const endMouse = e => {
        const mouse = this.mouse;
        if (!mouse || e.pointerId !== mouse.id) return;
        this.mouse = null;
        if (this.grid.hasPointerCapture(e.pointerId)) this.grid.releasePointerCapture(e.pointerId);
        delete this.dataset.dragging;
        if (mouse.moved) {
          this.suppressClickUntil = performance.now() + 450;
          this.goToPhysical(this.nearest(), false);
        }
      };
      window.addEventListener('pointerup', endMouse, {signal});
      this.grid.addEventListener('pointercancel', endMouse, {signal});
      this.grid.addEventListener('lostpointercapture', endMouse, {signal});
      this.grid.addEventListener('dragstart', e => { if (this.media.matches) e.preventDefault(); }, {signal});
      this.addEventListener('click', e => {
        if (!this.media.matches) return;
        const step = e.target.closest('[data-step]');
        const dot = e.target.closest('[data-slide]');
        if (step) this.goToPhysical(this.nearest() + Number(step.dataset.step));
        if (dot) this.goToLogical(Number(dot.dataset.slide));
        const card = e.target.closest(this.cardSelector);
        if (!card) return;
        if (e.detail !== 0 && performance.now() < (this.suppressClickUntil || 0)) { e.preventDefault(); return; }
        if (this.slides[this.nearest()] !== card) {
          e.preventDefault();
          this.goToPhysical(this.slides.indexOf(card));
        }
      }, {signal});
      this.addEventListener('keydown', e => {
        if (!this.media.matches || !['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
        e.preventDefault();
        const index = e.key === 'Home' ? 0 : e.key === 'End' ? this.cards.length - 1 : (this.current + (e.key === 'ArrowRight' ? 1 : -1) + this.cards.length) % this.cards.length;
        this.goToLogical(index);
        if (e.target.closest(this.cardSelector)) this.cards[index].focus({preventScroll:true});
      }, {signal});
      this.media.addEventListener('change', () => this.layout(), {signal});
      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => this.goToPhysical(this.cloneCount + this.current, true), 80);
      }, {signal});
      this.dataset.ready = '';
      this.layout();
    }
    layout() {
      this.grid.querySelectorAll('.kh-carousel-slot').forEach(slot => slot.replaceWith(...slot.childNodes));
      this.grid.querySelectorAll('[data-carousel-clone]').forEach(card => card.remove());
      this.cloneCount = 0;
      this.toggleAttribute('data-native', this.media.matches);
      if (!this.media.matches) {
        this.cards.forEach(card => {
          card.removeAttribute('style');
          card.removeAttribute('tabindex');
          card.removeAttribute('aria-hidden');
          card.toggleAttribute('data-active', true);
        });
        this.slides = this.cards;
        return;
      }
      this.cloneCount = Math.min(2, this.cards.length - 1);
      const clone = card => {
        const copy = card.cloneNode(true);
        copy.dataset.carouselClone = '';
        copy.removeAttribute('id');
        copy.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
        copy.setAttribute('aria-hidden', 'true');
        copy.tabIndex = -1;
        return copy;
      };
      const before = document.createDocumentFragment();
      if (this.cloneCount) this.cards.slice(-this.cloneCount).forEach(card => before.appendChild(clone(card)));
      this.grid.prepend(before);
      this.cards.slice(0, this.cloneCount).forEach(card => this.grid.appendChild(clone(card)));
      this.slides = [...this.grid.querySelectorAll(this.cardSelector)];
      this.slides.forEach(card => {
        const slot = document.createElement('div');
        slot.className = 'kh-carousel-slot';
        card.before(slot);
        slot.appendChild(card);
      });
      requestAnimationFrame(() => this.goToPhysical(this.cloneCount + this.current, true));
    }
    target(index) {
      const slot = this.slides[index].parentElement;
      return slot.offsetLeft + slot.offsetWidth / 2 - this.grid.clientWidth / 2;
    }
    nearest() {
      if (!this.slides?.length) return 0;
      let best = 0, distance = Infinity;
      this.slides.forEach((card, i) => {
        const d = Math.abs(this.target(i) - this.grid.scrollLeft);
        if (d < distance) { distance = d; best = i; }
      });
      return best;
    }
    goToLogical(index) {
      let candidates = this.slides.map((card, i) => Number(card.dataset.carouselIndex) === index ? i : -1).filter(i => i >= 0);
      candidates.sort((a,b) => Math.abs(this.target(a) - this.grid.scrollLeft) - Math.abs(this.target(b) - this.grid.scrollLeft));
      this.goToPhysical(candidates[0]);
    }
    goToPhysical(index, instant = false) {
      if (!this.media.matches || !this.slides?.length) return;
      index = Math.max(0, Math.min(this.slides.length - 1, index));
      this.grid.scrollTo({left:this.target(index), behavior:instant || this.reduce.matches ? 'instant' : 'smooth'});
      this.paint();
      clearTimeout(this.settleTimer);
      this.settleTimer = setTimeout(() => this.settle(), instant ? 30 : 180);
    }
    queuePaint() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = 0; this.paint(); });
    }
    paint() {
      if (!this.media.matches || !this.slides?.length) return;
      const left = this.grid.scrollLeft;
      const positions = this.slides.map((card, i) => this.target(i));
      const nearest = positions.reduce((best, value, i) => Math.abs(value - left) < Math.abs(positions[best] - left) ? i : best, 0);
      this.current = Number(this.slides[nearest].dataset.carouselIndex);
      const stride = this.slides.length > 1 ? this.slides[1].parentElement.offsetLeft - this.slides[0].parentElement.offsetLeft : 1;
      this.slides.forEach((card, i) => {
        const distance = (positions[i] - left) / stride;
        const n = Math.abs(distance), active = i === nearest;
        card.style.setProperty('--depth', -Math.min(n,2) * 65 + 'px');
        card.style.setProperty('--turn', -Math.max(-1,Math.min(1,distance)) * 14 + 'deg');
        card.style.setProperty('--scale', Math.max(.6,1 - n * .18));
        card.style.setProperty('--opacity', Math.max(0,1 - n * .4));
        card.style.zIndex = String(100 - Math.round(n * 20));
        card.parentElement.style.zIndex = card.style.zIndex;
        card.style.pointerEvents = n > 2.25 ? 'none' : '';
        card.toggleAttribute('data-active', active);
        card.tabIndex = active ? 0 : -1;
        card.setAttribute('aria-hidden', String(!active));
      });
      this.dots.forEach((dot,i) => dot.setAttribute('aria-pressed', String(i === this.current)));
    }
    settle() {
      if (this.mouse || !this.media.matches) return;
      this.paint();
      const nearest = this.nearest();
      if (this.slides[nearest]?.hasAttribute('data-carousel-clone')) {
        this.grid.scrollTo({left:this.target(this.cloneCount + this.current),behavior:'instant'});
        this.paint();
      }
      const status = this.querySelector('[data-status], [data-carousel-status]');
      if (status) status.textContent = String(this.current + 1).padStart(2,'0') + ' / ' + String(this.cards.length).padStart(2,'0');
    }
    disconnectedCallback() {
      clearTimeout(this.settleTimer);
      clearTimeout(this.resizeTimer);
      cancelAnimationFrame(this.frame);
      this.grid?.querySelectorAll('.kh-carousel-slot').forEach(slot => slot.replaceWith(...slot.childNodes));
      this.grid?.querySelectorAll('[data-carousel-clone]').forEach(card => card.remove());
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('kensui-depth-carousel', class extends KensuiNativeCarousel {});
  customElements.define('kensui-best-carousel', class extends KensuiNativeCarousel {});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kensui-grip-launch"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kensui-grip-launch')) {
    customElements.define('kensui-grip-launch', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const {signal} = this.controller;
        const films = [...this.querySelectorAll('[data-kgl-film]')];
        const videos = films.map(film => film.querySelector('video'));
        const offers = [...this.querySelectorAll('[data-kgl-offer]')];
        const buttons = [...this.querySelectorAll('[data-kgl-finish]')];
        const playButton = this.querySelector('[data-kgl-play]');
        const label = this.querySelector('[data-kgl-label]');
        const icon = this.querySelector('[data-kgl-icon]');
        const error = this.querySelector('[data-kgl-error]');
        const reduced = matchMedia('(prefers-reduced-motion: reduce)');
        let current = Number(this.dataset.current ?? 2);
        let inView = false;
        let nearView = false;
        let userPaused = this.userPaused === true;
        let attempt = 0;
        videos.forEach(video => { video.controls = false; video.muted = true; });
        this.querySelector('[data-kgl-controls]').hidden = false;
        playButton.hidden = false;
        const sync = () => {
          const paused = videos[current].paused;
          label.textContent = paused ? label.dataset.play : label.dataset.pause;
          icon.textContent = paused ? '▶' : 'Ⅱ';
        };
        const pause = () => { attempt++; videos.forEach(video => video.pause()); sync(); };
        const play = async () => {
          const video = videos[current];
          const id = ++attempt;
          error.hidden = true;
          if (video.error) video.load();
          try { await video.play(); }
          catch (reason) {
            if (signal.aborted || id !== attempt || reason.name === 'AbortError') return;
            if (reason.name !== 'NotAllowedError') error.hidden = false;
            sync();
          }
        };
        const warm = () => {
          if (!nearView || document.hidden || reduced.matches || navigator.connection?.saveData || userPaused) return;
          const video = videos[current];
          if (video.dataset.kglPrepared) return;
          video.dataset.kglPrepared = 'true';
          video.preload = 'auto';
          if (video.readyState === 0 && video.networkState !== 2) video.load();
        };
        const automatic = () => {
          warm();
          if (inView && !document.hidden && !reduced.matches && !navigator.connection?.saveData && !userPaused) play();
          else pause();
        };
        const choose = index => {
          pause();
          current = index;
          this.dataset.current = String(index);
          films.forEach((film, position) => { film.hidden = position !== index; });
          offers.forEach(offer => { offer.hidden = Number(offer.dataset.kglOffer) !== index; });
          buttons.forEach((button, position) => button.setAttribute('aria-pressed', String(position === index)));
          error.hidden = true;
          automatic();
        };
        buttons.forEach((button, index) => button.addEventListener('click', () => choose(index), {signal}));
        playButton.addEventListener('click', () => {
          userPaused = !videos[current].paused;
          this.userPaused = userPaused;
          if (userPaused) pause();
          else play();
        }, {signal});
        videos.forEach((video, index) => {
          video.addEventListener('play', sync, {signal});
          video.addEventListener('pause', sync, {signal});
          video.addEventListener('error', () => { if (current === index) error.hidden = false; }, {signal});
        });
        document.addEventListener('visibilitychange', automatic, {signal});
        reduced.addEventListener('change', automatic, {signal});
        navigator.connection?.addEventListener('change', automatic, {signal});
        if ('IntersectionObserver' in window) {
          this.warmObserver = new IntersectionObserver(entries => {
            if (signal.aborted) return;
            nearView = entries[0].isIntersecting;
            warm();
          }, {rootMargin: '600px 0px', threshold: 0});
          this.warmObserver.observe(this.querySelector('.kgl-media'));
          this.observer = new IntersectionObserver(entries => {
            if (signal.aborted) return;
            inView = entries[0].isIntersecting && entries[0].intersectionRatio >= .3;
            automatic();
          }, {threshold:[0,.3]});
          this.observer.observe(this.querySelector('.kgl-media'));
        }
        choose(current);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        this.warmObserver?.disconnect();
        this.querySelectorAll('video').forEach(video => video.pause());
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kensui-hover-image"] && !Shopify.designMode) return;
  try {
    (() => {
    const bind = (root) => {
      root.querySelectorAll('[data-kensui-hover-image]').forEach((image) => {
        if (image.dataset.kensuiHoverBound) return;
        image.dataset.kensuiHoverBound = 'true';
        const ready = () => {
          const card = image.closest('[data-kensui-hover]');
          if (card) card.classList.toggle('kensui-hover-ready', image.complete && image.naturalWidth > 1);
        };
        image.addEventListener('load', ready);
        image.addEventListener('error', ready);
        ready();
      });
    };
    bind(document);
    document.addEventListener('shopify:section:load', (event) => bind(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kensui-marquee-controller"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kensui-marquee')) {
    customElements.define('kensui-marquee', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.kensui-marquee__track');
        this.group = this.track?.querySelector('.kensui-marquee__group');
        this.sequence = this.group?.querySelector('.kensui-marquee__sequence');
        if (!this.sequence || this.observer) return;
        const queue = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.fill());
        };
        this.observer = new ResizeObserver(queue);
        this.observer.observe(this);
        this.observer.observe(this.sequence);
        queue();
        document.fonts.ready.then(() => { if (this.isConnected) queue(); });
      }
      fill() {
        const unitWidth = this.sequence.getBoundingClientRect().width;
        const viewportWidth = this.clientWidth;
        if (!unitWidth || !viewportWidth) return;
        const repeats = Math.max(1, Math.ceil(viewportWidth / unitWidth));
        const sizeKey = repeats + ':' + unitWidth;
        if (sizeKey === this.sizeKey) return;
        this.sizeKey = sizeKey;
        this.group.querySelectorAll('[data-marquee-copy]').forEach(copy => copy.remove());
        for (let index = 1; index < repeats; index++) {
          const copy = this.sequence.cloneNode(true);
          copy.setAttribute('aria-hidden', 'true');
          copy.setAttribute('data-marquee-copy', '');
          this.group.append(copy);
        }
        while (this.track.children.length > 1) this.track.lastElementChild.remove();
        const duplicate = this.group.cloneNode(true);
        duplicate.setAttribute('aria-hidden', 'true');
        this.track.append(duplicate);
        this.style.setProperty('--marquee-duration', (Number(this.dataset.cycleDuration) || 52) * repeats + 's');
        this.setAttribute('data-ready', '');
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
        cancelAnimationFrame(this.frame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kensui-plate-motion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kensui-plate-motion')) {
    customElements.define('kensui-plate-motion', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) { this.resumeConnections(); return; }
        this.initialized = true;
        const video = this.querySelector('video');
        const toggle = this.querySelector('[data-motion-toggle]');
        const label = this.querySelector('[data-motion-label]');
        const icon = this.querySelector('[data-motion-icon]');
        const error = this.querySelector('[data-motion-error]');
        const weights = [...this.querySelectorAll('[data-motion-weight]')];
        const root = this.closest('[data-kgp]');
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        const connection = navigator.connection;
        let inView = false;
        let nearView = false;
        let prepared = false;
        let userPaused = false;
        let playAttempt = 0;
        video.controls = false;
        video.muted = true;
        toggle.hidden = false;
        this.querySelector('.kgp-motion-weights').hidden = false;
        const sync = () => {
          label.textContent = video.paused ? label.dataset.play : label.dataset.pause;
          icon.textContent = video.paused ? '▶' : 'Ⅱ';
          const index = Math.min(3, Math.floor(video.currentTime / 2));
          weights.forEach((button, position) => {
            if (position === index) button.dataset.active = 'true';
            else delete button.dataset.active;
          });
        };
        const prepare = () => {
          if (prepared) return;
          prepared = true;
          video.preload = 'auto';
          if (video.readyState === 0 && video.paused) video.load();
        };
        const play = async () => {
          const attempt = ++playAttempt;
          error.hidden = true;
          if (video.error) video.load();
          else prepare();
          try { await video.play(); }
          catch (reason) {
            if (attempt !== playAttempt || reason.name === 'AbortError') return;
            if (reason.name !== 'NotAllowedError') error.hidden = false;
            sync();
          }
        };
        const pause = () => { playAttempt++; video.pause(); sync(); };
        const automaticAllowed = () => this.isConnected && !document.hidden && !reduced.matches && !connection?.saveData && !userPaused;
        const warm = () => { if (nearView && automaticAllowed()) prepare(); };
        const automaticPlayback = () => {
          warm();
          if (inView && automaticAllowed()) play();
          else pause();
        };
        toggle.addEventListener('click', () => {
          userPaused = !video.paused;
          if (userPaused) pause();
          else play();
        });
        video.addEventListener('timeupdate', sync);
        video.addEventListener('pause', sync);
        video.addEventListener('play', () => {
          sync();
          root?.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); });
          root?.querySelectorAll('[data-long-video] iframe').forEach(frame => {
            frame.contentWindow?.postMessage(JSON.stringify({event:'command', func:'pauseVideo', args:[]}), 'https://www.youtube-nocookie.com');
          });
        });
        video.addEventListener('error', () => { error.hidden = false; sync(); });
        this.pausePlayback = pause;
        this.resumeConnections = () => {
          inView = false;
          nearView = false;
          this.controller = new AbortController();
          const options = {signal: this.controller.signal};
          root?.addEventListener('play', event => {
            if (event.target !== video && event.target.tagName === 'VIDEO') { userPaused = true; pause(); }
          }, {...options, capture: true});
          root?.addEventListener('click', event => {
            if (event.target.closest('[data-load-video]')) { userPaused = true; pause(); }
          }, options);
          document.addEventListener('visibilitychange', automaticPlayback, options);
          reduced.addEventListener('change', automaticPlayback, options);
          connection?.addEventListener('change', automaticPlayback, options);
          if ('IntersectionObserver' in window) {
            this.preloadObserver = new IntersectionObserver(entries => {
              if (options.signal.aborted) return;
              nearView = entries[0].isIntersecting;
              warm();
            }, {rootMargin: '600px 0px', threshold: 0});
            this.preloadObserver.observe(video);
            this.observer = new IntersectionObserver(entries => {
              if (options.signal.aborted) return;
              inView = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.35;
              automaticPlayback();
            }, {threshold: [0, 0.35]});
            this.observer.observe(video);
          }
        };
        this.resumeConnections();
        sync();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.preloadObserver?.disconnect();
        this.controller?.abort();
        this.pausePlayback?.();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kensui-spin-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  const SEGMENTS = ['discount_10', 'chrome_set', null, null, 'discount_10', null];
  const DAY = 86400000;
  const normalize = angle => ((angle % 360) + 360) % 360;
  const landingJitter = (random = Math.random) => (random() < .5 ? -1 : 1) * (6 + random() * 9);
  const landingAngle = (start, segment, offset = 0) => start + 1800 + normalize(-segment * 60 + offset - start);
  function validateResult(value, now = Date.now(), allowExpired = false) {
    if (!value || !['discount_10', 'chrome_set'].includes(value.outcome) || value.apiVersion !== 1 || value.emailCaptured !== true ||
      typeof value.entryId !== 'string' || !/^[\w-]{1,128}$/.test(value.entryId) ||
      !Number.isInteger(value.segment) || value.segment < 0 || value.segment >= SEGMENTS.length || SEGMENTS[value.segment] !== value.outcome) throw new Error('Invalid result');
    const expiry = Date.parse(value.expiresAt);
    if (!Number.isFinite(expiry) || (!allowExpired && expiry <= now)) throw new Error('Expired result');
    const result = { apiVersion: 1, emailCaptured: true, entryId: value.entryId, outcome: value.outcome, segment: value.segment, expiresAt: value.expiresAt };
    if (value.outcome === 'discount_10') {
      if (typeof value.code !== 'string' || !/^[A-Za-z0-9_-]{1,64}$/.test(value.code)) throw new Error('Invalid code');
      result.code = value.code;
    }
    if (value.outcome === 'chrome_set') {
      if (typeof value.claimReference !== 'string' || !/^[A-Za-z0-9_-]{1,80}$/.test(value.claimReference)) throw new Error('Invalid claim');
      result.claimReference = value.claimReference;
    }
    return result;
  }
  function createTracker(preview, campaign, win = window, doc = document) {
    const measurementId = 'G-W5RY8NLWJD';
    const names = {
      open: ['ksp_popup_view'], close: ['ksp_popup_dismiss'],
      submit: ['ksp_popup_spin', 'ksp_email_submit'], email_success: ['ksp_email_success'],
      result: ['ksp_prize_result'], result_view: ['ksp_result_view'],
      teaser_click: ['ksp_teaser_click'], copy: ['ksp_code_copy'],
      shop_click: ['ksp_popup_shop_click'], claim_click: ['ksp_prize_claim_click'], error: ['ksp_popup_error']
    };
    const once = new Set();
    let pending = [];
    let loading = false;
    function flush() {
      try {
        const privacy = win.Shopify?.customerPrivacy;
        if (!privacy?.analyticsProcessingAllowed) {
          if (!loading && win.Shopify?.loadFeatures) {
            loading = true;
            win.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
              loading = false;
              if (!error && win.Shopify?.customerPrivacy?.analyticsProcessingAllowed) flush();
            });
          }
          return;
        }
        if (!privacy.analyticsProcessingAllowed()) { pending = []; return; }
        if (!pending.length) return;
        win.dataLayer = win.dataLayer || [];
        win.gtag = win.gtag || function() { win.dataLayer.push(arguments); };
        if (!win.__ksp6GA4Configured) {
          if (!doc.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
            const script = doc.createElement('script');
            script.async = true;
            script.src = 'https://www.googletagmanager.com/gtag/js?id=' + measurementId;
            doc.head.appendChild(script);
          }
          win.gtag('js', new Date());
          win.gtag('config', measurementId, { send_page_view: false, user_properties: { ksp_variant: 'chrome_email_v1', ksp_plate: 'bumper6' } });
          win.__ksp6GA4Configured = true;
        }
        const events = pending;
        pending = [];
        for (const { action, params } of events) {
          if (['open', 'email_success', 'result'].includes(action)) once.add(action);
          win.dataLayer.push({ event: 'kensui_spin_' + action, campaign, variant: 'chrome_email_v1', plate: 'bumper6', ...params });
          for (const name of names[action]) win.gtag('event', name, { send_to: measurementId, ksp_campaign: campaign, ksp_variant: 'chrome_email_v1', ksp_plate: 'bumper6', ...params });
        }
      } catch {}
    }
    if (!preview) doc.addEventListener('visitorConsentCollected', flush);
    return (action, extra = {}) => {
      if (preview || !names[action]) return;
      if (['open', 'email_success', 'result'].includes(action)) {
        if (once.has(action) || pending.some(event => event.action === action)) return;
      }
      const params = {};
      if (['discount_10', 'chrome_set'].includes(extra.outcome)) params.outcome = extra.outcome;
      if (['request_error', 'unavailable'].includes(extra.reason)) params.reason = extra.reason;
      pending.push({ action, params });
      if (pending.length > 30) pending.shift();
      flush();
    };
  }
  function init() {
    const root = document.getElementById('ksp6');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const $ = selector => root.querySelector(selector);
    const msg = key => root.getAttribute('data-msg-' + key.replaceAll('_', '-')) || '';
    const preview = root.dataset.preview === 'true';
    const campaign = root.dataset.campaign;
    const dialog = $('.ksp6-dialog');
    const closeButton = $('.ksp6-close');
    const form = $('.ksp6-form');
    const email = $('#ksp6-email');
    const submit = form.querySelector('[type=submit]');
    const error = $('.ksp6-error');
    const status = $('.ksp6-status');
    const plate = $('.ksp6-plate');
    const teaser = $('.ksp6-teaser');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const storageKey = 'ksp6:' + campaign + ':';
    const cooldown = 7 * DAY;
    const seenCookie = 'kp_seen';
    const convertedKey = 'ksp_converted';
    let converted = false;
    let state = 'idle';
    let animation = null;
    let angle = 0;
    let result = null;
    let lastFocus = null;
    let oldOverflow = '';
    let attempt = null;
    let opened = false;
    let closeTimer;
    let endpoint;
    let discountRequest = null;
    let discountApplied = '';
    function applyDiscount() {
      if (preview || result?.outcome !== 'discount_10' || Date.parse(result.expiresAt) <= Date.now()) return;
      if (discountRequest || discountApplied === result.code) return discountRequest;
      const code = result.code;
      const cartRoot = window.Shopify?.routes?.root || '/';
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 10000);
      discountRequest = fetch(cartRoot + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin', keepalive: true, signal: controller.signal,
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: code })
      }).then(response => {
        if (!response.ok) throw new Error('discount_pending');
        discountApplied = code;
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }).catch(() => {}).finally(() => { clearTimeout(timer); discountRequest = null; });
      return discountRequest;
    }
    document.addEventListener('cart:added', () => { if (!discountApplied) applyDiscount(); });
    window.addEventListener('online', applyDiscount);
    function read(key, session = false) {
      try { return JSON.parse((session ? sessionStorage : localStorage).getItem(storageKey + key)); } catch { return null; }
    }
    function write(key, value, session = false) {
      if (preview) return;
      try { (session ? sessionStorage : localStorage).setItem(storageKey + key, JSON.stringify(value)); } catch {}
    }
    function recent(key, duration) { const stamp = read(key); return Number.isFinite(stamp) && Date.now() - stamp < duration; }
    function hasCookie(name) {
      try { return document.cookie.split(';').some(cookie => cookie.trim().startsWith(name + '=')); } catch { return false; }
    }
    function setCookie(name, days) {
      if (preview) return;
      try {
        document.cookie = name + '=1; Max-Age=' + days * 86400 + '; Path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
      } catch {}
    }
    function hasSeen() {
      return !preview && (hasCookie(seenCookie) || recent('shown', cooldown) || recent('dismissed', cooldown));
    }
    function markSeen() {
      write('shown', Date.now());
      setCookie(seenCookie, 7);
    }
    function hasConverted() {
      if (preview) return false;
      if (converted || hasCookie(convertedKey)) return true;
      try { return Boolean(localStorage.getItem(convertedKey)); } catch { return false; }
    }
    function markConverted() {
      if (preview) return;
      converted = true;
      try { localStorage.setItem(convertedKey, '1'); } catch {}
      setCookie(convertedKey, 400);
    }
    const track = createTracker(preview, campaign);
    document.addEventListener('visitorConsentCollected', () => {
      if (dialog.open && !result) track('open');
    });
    function stopRotation() {
      if (animation) {
        const matrix = new DOMMatrixReadOnly(getComputedStyle(plate).transform);
        angle = normalize(Math.atan2(matrix.b, matrix.a) * 180 / Math.PI);
        animation.cancel();
        animation = null;
      }
      plate.style.transform = 'rotate(' + angle + 'deg)';
      return angle;
    }
    function idleRotation() {
      if (!['idle', 'requesting'].includes(state) || !dialog.open || document.hidden || reduced.matches) return;
      stopRotation();
      animation = plate.animate([{ transform: 'rotate(' + angle + 'deg)' }, { transform: 'rotate(' + (angle + 360) + 'deg)' }], { duration: 24000, iterations: Infinity, easing: 'linear' });
    }
    async function land(value, animate = true) {
      const saved = read('landing');
      const offset = saved?.entryId === value.entryId && Number.isFinite(saved.offset) && Math.abs(saved.offset) >= 6 && Math.abs(saved.offset) <= 15 ? saved.offset : landingJitter();
      write('landing', { entryId: value.entryId, offset });
      const start = stopRotation();
      const end = landingAngle(start, value.segment, offset);
      if (animate && !reduced.matches && dialog.open && !document.hidden) {
        const spin = plate.animate([{ transform: 'rotate(' + start + 'deg)' }, { transform: 'rotate(' + end + 'deg)' }], { duration: 3000, easing: 'cubic-bezier(.12,.65,.09,1)', fill: 'forwards' });
        animation = spin;
        try { await spin.finished; } catch {}
        spin.cancel();
        if (animation === spin) animation = null;
      }
      angle = normalize(end);
      plate.style.transform = 'rotate(' + angle + 'deg)';
    }
    function showTeaser() {
      teaser.hidden = dialog.open || (!result && (hasConverted() || (!opened && hasSeen()))) || recent('teaserHidden', cooldown);
      $('.ksp6-reopen').textContent = result ? msg('result') : root.querySelector('.ksp6-eyebrow').textContent;
    }
    function replayEntrance() {
      dialog.scrollTop = 0;
      dialog.classList.remove('ksp6-entering');
      void dialog.offsetWidth;
      dialog.classList.add('ksp6-entering');
    }
    function openPopup(automatic = false) {
      if (!result && hasConverted()) { teaser.hidden = true; return; }
      if (automatic && hasSeen()) return;
      if (dialog.open || document.hidden || (automatic && document.body.classList.contains('kc-open'))) return;
      lastFocus = document.activeElement;
      oldOverflow = document.documentElement.style.overflow;
      clearTimeout(closeTimer);
      closeButton.disabled = true;
      closeButton.classList.remove('ksp6-close-ready');
      dialog.showModal();
      replayEntrance();
      document.documentElement.style.overflow = 'hidden';
      dialog.scrollTop = 0;
      teaser.hidden = true;
      opened = true;
      if (!result) markSeen();
      if (result) $('.ksp6-result h3').focus({ preventScroll: true });
      else $('.ksp6-title').focus({ preventScroll: true });
      closeTimer = setTimeout(() => {
        if (!dialog.open) return;
        closeButton.disabled = false;
        closeButton.classList.add('ksp6-close-ready');
      }, 2500);
      idleRotation();
      track(result ? 'result_view' : 'open');
    }
    function closePopup() {
      if (dialog.open) dialog.close();
    }
    dialog.addEventListener('close', () => {
      clearTimeout(closeTimer);
      closeButton.disabled = true;
      closeButton.classList.remove('ksp6-close-ready');
      stopRotation();
      document.documentElement.style.overflow = oldOverflow;
      showTeaser();
      if (lastFocus && lastFocus.isConnected) lastFocus.focus({ preventScroll: true });
      track('close');
    });
    $('.ksp6-close').addEventListener('click', closePopup);
    $('.ksp6-reopen').addEventListener('click', () => { track('teaser_click'); openPopup(); });
    $('.ksp6-teaser-close').addEventListener('click', () => { write('teaserHidden', Date.now()); markSeen(); teaser.hidden = true; });
    reduced.addEventListener('change', () => {
      if (reduced.matches) stopRotation(); else idleRotation();
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopRotation(); else idleRotation();
    });
    function setBusy(busy) {
      email.disabled = busy;
      submit.disabled = busy;
      form.setAttribute('aria-busy', String(busy));
      submit.querySelector('span').textContent = msg(busy ? 'spinning' : 'spin');
      root.querySelectorAll('.ksp6-preview-reset, .ksp6-preview-replay').forEach(button => { button.disabled = busy; });
    }
    function showError(message) {
      error.textContent = message;
      error.hidden = false;
    }
    function renderResult(value, focus = true) {
      result = value;
      state = 'result';
      dialog.dataset.state = state;
      dialog.setAttribute('aria-labelledby', 'ksp6-result-title');
      form.hidden = true;
      $('.ksp6-result').hidden = false;
      const title = $('.ksp6-result h3');
      const body = $('.ksp6-result-body');
      const eyebrow = $('.ksp6-result-eyebrow');
      const codebox = $('.ksp6-codebox');
      const expiry = $('.ksp6-expiry');
      const shop = $('.ksp6-shop');
      const isDiscount = value.outcome === 'discount_10';
      dialog.dataset.outcome = value.outcome;
      $('.ksp6-title').hidden = isDiscount;
      $('.ksp6-prize').hidden = isDiscount;
      $('.ksp6-eyebrow').hidden = true;
      root.querySelectorAll('.ksp6-labels > g').forEach((label, index) => {
        label.classList.toggle('ksp6-winning-label', index === value.segment);
      });
      eyebrow.hidden = !isDiscount;
      eyebrow.textContent = msg('winner');
      codebox.hidden = !isDiscount && value.outcome !== 'chrome_set';
      $('.ksp6-copy').hidden = !isDiscount;
      $('.ksp6-copy').textContent = msg('copy');
      expiry.hidden = !isDiscount;
      shop.textContent = msg(isDiscount ? 'shop' : 'continue');
      shop.href = shop.dataset.defaultHref || (shop.dataset.defaultHref = shop.getAttribute('href'));
      if (isDiscount) {
        title.textContent = msg('discount_title').replace('__AMOUNT__', '10');
        body.textContent = msg('discount_body');
        $('.ksp6-code').textContent = value.code;
        expiry.textContent = msg('expiry').replace('__DATE__', new Date(value.expiresAt).toLocaleDateString(document.documentElement.lang || 'en', { month: 'short', day: 'numeric', year: 'numeric' }));
        if (!preview) shop.href = '/discount/' + encodeURIComponent(value.code) + '?redirect=' + encodeURIComponent(location.pathname + location.search);
        applyDiscount();
      } else if (value.outcome === 'chrome_set') {
        title.textContent = msg('chrome_title');
        body.textContent = msg('chrome_body');
        $('.ksp6-code').textContent = msg('claim') + ': ' + value.claimReference;
        shop.textContent = msg('claim_prize');
        if (!preview) shop.href = 'mailto:info@kensuifitness.com?subject=' + encodeURIComponent('Chrome set prize claim ' + value.claimReference);
      }
      status.textContent = title.textContent;
      dialog.scrollTop = 0;
      if (dialog.open && focus) title.focus({ preventScroll: true });
      showTeaser();
    }
    function makePreviewResult() {
      const outcome = $('#ksp6-preview-outcome').value;
      return validateResult({ apiVersion: 1, emailCaptured: true, entryId: 'preview', outcome, segment: SEGMENTS.indexOf(outcome), expiresAt: new Date(Date.now() + 2 * DAY).toISOString(), code: 'SPIN10-C7K9P', claimReference: 'PREVIEW-CHROME-SET' });
    }
    async function requestResult(address) {
      if (preview) return makePreviewResult();
      if (!attempt || attempt.email !== address) attempt = { email: address, id: crypto.randomUUID() };
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 15000);
      try {
        if (!attempt.subscribed) {
          const subscription = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=QeupfE', {
            method: 'POST', credentials: 'omit', signal: controller.signal,
            headers: { 'Content-Type': 'application/json', revision: '2026-07-15' },
            body: JSON.stringify({ data: {
              type: 'subscription', attributes: {
                custom_source: 'Spin to Win popup (CHROME/BUMPER6)',
                profile: { data: { type: 'profile', attributes: { email: address } } }
              }, relationships: { list: { data: { type: 'list', id: 'YxDiSj' } } }
            } })
          });
          if (!subscription.ok) throw new Error('request_error');
          attempt.subscribed = true;
          markConverted();
          track('email_success');
        }
        const response = await fetch(endpoint.href, {
          method: 'POST', mode: 'cors', credentials: endpoint.origin === location.origin ? 'same-origin' : 'omit',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ campaignId: campaign, email: address, marketingConsent: true, consentVersion: 'email-spin-v1', idempotencyKey: attempt.id, locale: document.documentElement.lang || 'en' }),
          signal: controller.signal
        });
        if (!response.ok) throw new Error(response.status === 410 ? 'unavailable' : 'request_error');
        const result = validateResult(await response.json());
        fetch('https://a.klaviyo.com/client/profiles/?company_id=QeupfE', {
          method: 'POST', credentials: 'omit', keepalive: true,
          headers: { 'Content-Type': 'application/json', revision: '2026-07-15' },
          body: JSON.stringify({ data: { type: 'profile', attributes: { email: address, properties: {
            spin_code: result.code || null, spin_claim_reference: result.claimReference || null,
            spin_outcome: result.outcome, spin_entry_id: result.entryId, ksp_variant: 'chrome_email_v1', ksp_plate: 'bumper6'
          } } } })
        }).catch(() => {});
        return result;
      } finally { clearTimeout(timer); }
    }
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (state !== 'idle') return;
      email.value = email.value.trim();
      error.hidden = true;
      email.removeAttribute('aria-invalid');
      if (!email.value || !email.validity.valid) {
        email.setAttribute('aria-invalid', 'true');
        showError(msg('email_error'));
        email.focus();
        return;
      }
      state = 'requesting';
      dialog.dataset.state = state;
      setBusy(true);
      status.textContent = msg('spinning');
      track('submit');
      try {
        const value = await requestResult(email.value);
        write('result', value);
        state = 'spinning';
        dialog.dataset.state = state;
        await land(value);
        renderResult(value);
        track('result', { outcome: value.outcome });
      } catch (failure) {
        track('error', { reason: failure.message === 'unavailable' ? 'unavailable' : 'request_error' });
        stopRotation();
        state = 'idle';
        dialog.dataset.state = state;
        showError(msg(failure.message === 'unavailable' ? 'unavailable' : 'request_error'));
        status.textContent = '';
        idleRotation();
      } finally { setBusy(false); }
    });
    email.addEventListener('input', () => { error.hidden = true; email.removeAttribute('aria-invalid'); });
    $('.ksp6-copy').addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(result.code);
        track('copy');
        $('.ksp6-copy').textContent = msg('copied');
        status.textContent = msg('copied');
      } catch { status.textContent = msg('copy_error'); }
    });
    $('.ksp6-shop').addEventListener('click', event => {
      if (result?.outcome === 'discount_10') {
        event.preventDefault();
        closePopup();
        applyDiscount();
      }
      if (result) track(result.outcome === 'chrome_set' ? 'claim_click' : 'shop_click', { outcome: result.outcome });
    });
    if (preview) {
      $('.ksp6-preview-replay').addEventListener('click', replayEntrance);
      $('.ksp6-terms').addEventListener('click', event => { event.preventDefault(); status.textContent = msg('demo_terms'); });
      $('.ksp6-shop').addEventListener('click', event => { event.preventDefault(); closePopup(); });
      $('.ksp6-preview-reset').addEventListener('click', () => {
        if (state === 'requesting' || state === 'spinning') return;
        stopRotation();
        result = null;
        state = 'idle';
        dialog.dataset.state = state;
        delete dialog.dataset.outcome;
        $('.ksp6-title').hidden = false;
        $('.ksp6-prize').hidden = false;
        $('.ksp6-eyebrow').hidden = false;
        root.querySelectorAll('.ksp6-winning-label').forEach(label => label.classList.remove('ksp6-winning-label'));
        form.hidden = false;
        dialog.setAttribute('aria-labelledby', 'ksp6-title');
        $('.ksp6-result').hidden = true;
        status.textContent = '';
        error.hidden = true;
        setBusy(false);
        idleRotation();
      });
      openPopup();
      return;
    }
    try {
      endpoint = new URL(root.dataset.api, location.origin);
      const terms = new URL(root.dataset.terms, location.origin);
      if (!root.dataset.api || !root.dataset.terms || endpoint.username || endpoint.password ||
        (endpoint.protocol !== 'https:' && endpoint.origin !== location.origin) ||
        !['http:', 'https:'].includes(endpoint.protocol) || !['http:', 'https:'].includes(terms.protocol)) return;
    } catch { return; }
    const saved = read('result');
    if (saved) {
      try {
        validateResult(saved, Date.now(), true);
        markConverted();
        result = validateResult(saved);
        land(result, false);
        renderResult(result, false);
        showTeaser();
        return;
      } catch { result = null; write('result', null); }
    }
    if (hasConverted()) return;
    showTeaser();
    if (hasSeen()) return;
    const automaticReadyAt = Date.now() + 25000;
    function automaticOpen() {
      if (Date.now() < automaticReadyAt || opened || result) return;
      if (document.activeElement?.matches('input, textarea, select, [contenteditable="true"]')) return;
      openPopup(true);
    }
    setTimeout(automaticOpen, 25000);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) automaticOpen(); });

  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ksu-currency-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    document.querySelectorAll('[data-ksu-currency][open]').forEach(function (selector) {
      if (!selector.contains(event.target)) selector.open = false;
    });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    const selector = event.target.closest('[data-ksu-currency][open]');
    if (!selector) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    selector.open = false;
    selector.querySelector('summary').focus();
  }, true);
  } catch(e) { console.error(e); }
})();

})();
